// Plantillas de notificación para el panel HAUS.
// Añadir una nueva: copia el bloque y edita id/label/subject/body/cta.
// Los placeholders {proyecto} y {app_url} se reemplazan al enviar.

export const PLANTILLAS = [
  {
    id: 'vacia',
    label: '— Vacía (redactar desde cero) —',
    subject: '',
    body: '',
    cta_url: '',
    cta_label: '',
    preselect_roles: [],
  },
  {
    id: 'materialidad',
    label: 'Informe de materialidad publicado',
    subject: 'HAUS · Informe de materialidad de {proyecto} disponible',
    body: `Hola {nombre},

Ya está disponible el informe de materialidad HAUS para {proyecto}. Es una web interactiva con las 30 fichas HAUS de los materiales analizados, con sus certificaciones, huella de carbono y propuestas de mejora para BREEAM.

Dentro del informe encontrarás:
· Resumen por partidas con el estado de cada material (se mantiene / mejora / condición)
· Análisis técnico comparado de las propuestas HAUS vs presupuesto
· Descarga directa de las 30 fichas HAUS en PDF

También puedes acceder al informe desde el pliego de requisitos: en el criterio MAT 1 verás ahora un botón verde "Consultoría" que abre el informe.

Un saludo,
Equipo HAUS`,
    cta_url: 'https://appbyhaus.com/dashboards/materialidad-aires-test/',
    cta_label: 'Ver informe de materialidad',
    preselect_roles: ['arquitectura', 'promotor'],
  },
  {
    id: 'simulador_ag1',
    label: 'Simulador AG 1 (consumo de agua) habilitado',
    subject: 'HAUS · Nuevo simulador AG 1 en el pliego de {proyecto}',
    body: `Hola {nombre},

Hemos habilitado el simulador BREEAM AG 1 (consumo de agua) directamente dentro de la ficha AG 1 del pliego de {proyecto}, para que podáis probar alternativas de sanitarios y bañeras y ver en tiempo real cómo afecta a la puntuación.

El simulador trabaja en modo "sandbox": podéis cambiar datos y recalcular las veces que queráis sin tocar la evaluación oficial del asesor BREEAM.

Para probarlo, accede al pliego y abre la ficha de AG 1.

Un saludo,
Equipo HAUS`,
    cta_url: '{app_url}',
    cta_label: 'Entrar al pliego',
    preselect_roles: ['arquitectura', 'ingenieria'],
  },
  {
    id: 'consultoria_mat1',
    label: 'Botón Consultoría en MAT 1 activo',
    subject: 'HAUS · Consultoría de materialidad accesible desde MAT 1 · {proyecto}',
    body: `Hola {nombre},

Para facilitaros la consulta, hemos añadido un botón "Consultoría" en la ficha de MAT 1 (Impactos del ciclo de vida) del pliego de {proyecto}. Al pulsarlo se abre el informe de materialidad HAUS directamente, con todas las fichas y propuestas.

El objetivo es que, cuando trabajéis sobre MAT 1 o MAT 3, no tengáis que salir del pliego para consultar los datos del fabricante o nuestras recomendaciones.

Un saludo,
Equipo HAUS`,
    cta_url: '{app_url}',
    cta_label: 'Entrar al pliego',
    preselect_roles: ['arquitectura'],
  },
  {
    id: 'evidencia_subida',
    label: 'Nueva evidencia subida al pliego',
    subject: 'HAUS · Nueva evidencia disponible en el pliego de {proyecto}',
    body: `Hola {nombre},

Se ha subido una nueva evidencia al pliego de {proyecto}. Entra a revisarla cuando puedas; si todo está correcto, el criterio queda cerrado.

Si falta algo o hay que ajustar la evidencia, usa el campo "Comentario del asesor" en la ficha para pedir la corrección y el responsable recibirá la notificación.

Un saludo,
Equipo HAUS`,
    cta_url: '{app_url}',
    cta_label: 'Ir al pliego',
    preselect_roles: ['arquitectura', 'ingenieria', 'promotor'],
  },
  {
    id: 'cambio_fase',
    label: 'Cambio de fase del proyecto',
    subject: 'HAUS · {proyecto} avanza de fase',
    body: `Hola {nombre},

{proyecto} ha avanzado a una nueva fase. A partir de ahora, se activan los criterios BREEAM correspondientes y es momento de empezar a reunir las evidencias de esta nueva etapa.

Dentro del pliego verás ya las nuevas fichas marcadas como pendientes. Si tienes dudas sobre la documentación necesaria, consulta la "Guía" o la "Plantilla" en cada ficha, o escríbenos.

Un saludo,
Equipo HAUS`,
    cta_url: '{app_url}',
    cta_label: 'Entrar al pliego',
    preselect_roles: ['arquitectura', 'ingenieria', 'promotor', 'contratista'],
  },
  {
    id: 'entrega_lista_revision',
    label: 'Entrega lista para revisión',
    subject: 'HAUS · Entrega lista para revisión en {proyecto}',
    body: `Hola {nombre},

Ya tenemos lista la entrega del paquete de documentación de {proyecto}. Antes de enviarla al certificador BREEAM, nos gustaría que la revisarais y nos confirmarais que todo está correcto.

En el pliego podéis consultar cada ficha, descargar los documentos y comentar lo que haga falta. Si todo os parece bien, confirmad respondiendo a este correo y procederemos con la entrega oficial.

Un saludo,
Equipo HAUS`,
    cta_url: '{app_url}',
    cta_label: 'Revisar la entrega',
    preselect_roles: ['arquitectura', 'promotor'],
  },
  {
    id: 'recordatorio_pendientes',
    label: 'Recordatorio de evidencias pendientes',
    subject: 'HAUS · Recordatorio · evidencias pendientes en {proyecto}',
    body: `Hola {nombre},

Pasamos a recordaros que todavía quedan evidencias pendientes de subir al pliego de {proyecto}. En el panel podéis ver qué fichas os corresponden y cuáles aún no están cerradas.

Si tenéis cualquier duda sobre qué documentación aportar, revisad la "Guía" dentro de cada ficha o escribidnos directamente.

Un saludo,
Equipo HAUS`,
    cta_url: '{app_url}',
    cta_label: 'Ver mis fichas pendientes',
    preselect_roles: ['arquitectura', 'ingenieria', 'contratista'],
  },
  {
    id: 'innovacion_breeam_aprobada',
    label: 'Innovación BREEAM aprobada',
    subject: 'HAUS · ¡Innovación BREEAM aprobada para {proyecto}!',
    body: `Hola {nombre},

**¡Tenemos una noticia que nos hace mucha ilusión compartir!**

BREEAM ES, tras un análisis conjunto con BRE Reino Unido, ha **aprobado formalmente la innovación** presentada por HAUS en el marco del proyecto **{proyecto}**. ¡Un hito enorme para el equipo!

Esta aprobación es el reconocimiento oficial a una **herramienta propia desarrollada desde HAUS**, única en el mercado y hasta ahora inexistente en el ámbito de la certificación de sostenibilidad en edificación. Un paso pionero que confirma el valor diferencial que aporta nuestra forma de trabajar.

El proceso ha requerido una revisión muy detallada, y por eso celebramos especialmente este resultado. Ya hemos recibido la **documentación oficial de respaldo por parte de BREEAM ES**, que incorporaremos al expediente del proyecto.

Queremos daros las **gracias** a todo el equipo técnico, a la propiedad del proyecto y a cada una de las personas que habéis colaborado: este hito es también vuestro.

**¡Celebrémoslo juntos!**

Un fuerte abrazo,
Equipo HAUS Healthy Buildings`,
    cta_url: '',
    cta_label: '',
    preselect_roles: ['promotor', 'arquitectura', 'ingenieria', 'contratista', 'otro'],
  },
]

// Mapa id→plantilla para lookup rápido
export const PLANTILLA_BY_ID = Object.fromEntries(PLANTILLAS.map(p => [p.id, p]))

// Reemplaza placeholders en subject/body.
export function rellenarPlantilla(plantilla, { proyecto, app_url }) {
  const r = (s) => (s || '')
    .replace(/\{proyecto\}/g, proyecto || '')
    .replace(/\{app_url\}/g, app_url || '')
  return {
    ...plantilla,
    subject: r(plantilla.subject),
    body: r(plantilla.body),
    cta_url: r(plantilla.cta_url),
  }
}
